<template>
    <div>
        <p class="login-label u-mt16">图形验证码</p>
        <div class="login-captcha-container">
            <input type="text" v-model.trim="captcha"
                   class="form-item-base login-input"
                   :class="{'login-input--hasval': captcha}"
                   :maxlength="6" placeholder="请输入图形验证码"/>
            <img :src="captchaObj ? 'data:image/jpeg;base64,' + captchaObj.base64Data : ''" class="login-captcha" @click="changeCaptcha"/>
        </div>

        <p class="login-errmsg-container" v-if="validateMag">
            <span class="login-errmsg u-ml16">{{validateMag}}</span>
        </p>

        <a href="javascript:;" class="form-item-base login-btn u-mt16"
           :class="{'login-btn--active': captcha.length > 0}"
           @click="confirmCaptcha">
            <span>确定</span>
        </a>
    </div>
</template>

<script>
    import axios from 'axios'
    import UtilMixin from '../mixin/UtilMixin.vue'

    export default {
        mixins: [UtilMixin],
        props: ['mobile', 'type'],
        data: function() {
            return {
                captcha: '',
                captchaObj: '',
                validateMag: ''
            }
        },
        mounted: function() {
            this.changeCaptcha()
        },
        methods: {
            changeCaptcha: function() {
                axios.get('/api/login/captcha').then((res) => {
                    this.captchaObj = res.data
                })
            },
            confirmCaptcha: function() {
                if(!this.captcha) return
                let params = {
                    mobile: this.mobile,
                    app: meta.app,
                    captcha: this.captcha,
                    captchaKey: this.captchaObj.key
                }

                axios.post('/api/login/verifyCode', this.stringify(params)).then(({data}) => {
                    this.$emit('on-submit-captcha', data.key)
                }).catch(({ response }) => {  //获取验证码异常, 可以点击重新获取
                    this.validateMag = response.data.message
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Captcha.vue?4ce9b0dc